import React from 'react';
import { motion } from 'framer-motion';
export function ProductGalleryMid() {
  return <section className="bg-[#0A0A0A] py-10 md:py-16 px-4" data-id="element-76">
      <div className="max-w-6xl mx-auto space-y-5 md:space-y-8" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-78">
          <div className="overflow-hidden" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/cDruwosA5aR8MZr8hSYUtQ/misery_hast_balck_4.png" alt="Gorra Misery Black & Magenta vista lateral con bordado Bien Jalapeño" className="w-full h-[250px] md:h-[450px] object-cover hover:scale-105 transition-transform duration-700" data-id="element-80" />
          </div>
          <div className="overflow-hidden" data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/wZyB2dGPZ5EJctpDTyQG9V/misery_hast_balck.png" alt="Interior de seda magenta y visera de la gorra Misery" className="w-full h-[250px] md:h-[450px] object-cover hover:scale-105 transition-transform duration-700" data-id="element-82" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="text-center" data-id="element-83">
          <button onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-misery-purple hover:bg-misery-magenta transition-all duration-300 text-white font-bebas text-2xl md:text-3xl px-12 py-5 tracking-wider transform hover:scale-105" data-id="element-84">
            CONSÍGUELO AHORA
          </button>
        </motion.div>
      </div>
    </section>;
}